import { Avatar, Button, HStack, Input, Stack, Text, VStack } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { useRef } from 'react';
import { Controller } from 'react-hook-form';

import { SFSquareArrowUp } from '@assets/icons';
import { useUserStore } from '@store/app.store';
import { useAvatarUpload } from '@util/hooks';
import FormInput from '@components/general/form/form-input.component';

/**
 * @param {Object} props
 * @param {UseForm<OnboardingFormValues>} props.form
 */
const ProfileSetupStep = ({ form }) => {
  const fileInputRef = useRef();
  const user = useUserStore((state) => state.user);
  const queryClient = useQueryClient();
  const { isUploading, handleFileSelect } = useAvatarUpload(queryClient);

  return (
    <HStack
      py={4}
      w='full'
      flexDir={{ base: 'column', md: 'row' }}
      gap={8}
    >
      <VStack
        flex={1}
        gap={4}
      >
        <Avatar
          src={user?.avatar_url}
          name={user?.name}
          bgColor='#D9D9D9'
          sx={{
            '.chakra-avatar__initials': {
              fontSize: { base: '64px', md: '96px' },
              color: 'white'
            }
          }}
          boxSize={{ base: 32, md: 56 }}
        />
        <Input
          ref={fileInputRef}
          type='file'
          accept='image/*'
          display='none'
          onChange={handleFileSelect}
        />
        <Button
          isLoading={isUploading}
          leftIcon={<SFSquareArrowUp />}
          color='brandPrimary.primary'
          variant='link'
          onClick={() => fileInputRef?.current?.click()}
        >
          <Text variant='body-lighter-md'>Upload custom file</Text>
        </Button>
      </VStack>
      <Stack
        flex={1}
        gap={0}
      >
        <FormInput
          variant='labelCaps'
          label='Email'
          value={user?.email}
          isDisabled
        />
        <HStack>
          <Controller
            name='first_name'
            control={form.control}
            render={({ field }) => (
              <FormInput
                variant='labelCaps'
                label='First Name'
                placeholder='Enter your First Name'
                {...field}
              />
            )}
          />
          <Controller
            name='last_name'
            control={form.control}
            render={({ field }) => (
              <FormInput
                variant='labelCaps'
                label='Last Name'
                placeholder='Enter your Last Name'
                {...field}
              />
            )}
          />
        </HStack>
        <Controller
          name='tenant.name'
          control={form.control}
          render={({ field }) => (
            <FormInput
              variant='labelCaps'
              label='Organization Name'
              placeholder='Enter your organization name'
              {...field}
            />
          )}
        />

        <Controller
          name='title'
          control={form.control}
          render={({ field }) => (
            <FormInput
              variant='labelCaps'
              label='Title'
              placeholder='Enter your title'
              {...field}
            />
          )}
        />
        <Controller
          name='department'
          control={form.control}
          render={({ field }) => (
            <FormInput
              variant='labelCaps'
              label='Department'
              placeholder='Enter your department'
              {...field}
            />
          )}
        />
      </Stack>
    </HStack>
  );
};

export default ProfileSetupStep;
